import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Row,
  Typography,
  List,
  Tooltip,
  Flex,
  Modal,
  Divider,
  Popconfirm,
  Skeleton,
} from "antd";
import "../../../styles/Configuration/SiteView.css";
import AreaForm from "./AreaForm";
import AreaDetails from "./AreaDetails";
import { useEffect, useState, useContext } from "react";
import { IndexContext } from "../../../context/IndexContext";
import useFetch from "../../../hooks/useFetch";

const { Title } = Typography;

export default function AreaView(props) {
  const { siteID } = props;

  const [loading, setLoading] = useState(false);

  const [fetchWrapper] = useFetch();

  const [isAddAreaModalOpen, setIsAddAreaModalOpen] = useState(false);
  const [isEditAreaModalOpen, setIsEditAreaModalOpen] = useState(false);
  const [selectedInfoArea, setSelectedInfoArea] = useState(null);

  const [areaDetails, setAreaDetails] = useState([]);
  const [selectedEditArea, setSelectedEditArea] = useState(null); // this selected area is the area to be edited

  // load index context
  const { messageApi } = useContext(IndexContext);

  /* API to get area details */
  function getAreaDetails() {
    setLoading(true);
    fetchWrapper({
      endpoint_url: "site_management/getAreaDetails",
      body: {
        site_id: siteID,
      },
      onSuccess: (fetch_output) => {
        setLoading(false);
        if (fetch_output.status === true) {
          setAreaDetails(fetch_output.area_details);
        }
      },
    });
  }

  /* API to delete area */
  function deleteArea(area_id) {
    setLoading(true);

    fetchWrapper({
      endpoint_url: "site_management/deleteArea",
      body: {
        area_id: area_id,
      },
      onSuccess: (fetch_output) => {
        setLoading(false);

        if (fetch_output.status === true) {
          messageApi.open({
            type: "success",
            content: fetch_output.message,
          });
          getAreaDetails();
          setSelectedInfoArea(null);
        } else {
          messageApi.open({
            type: "error",
            content: fetch_output.error,
          });
        }
      },
    });
  }

  useEffect(() => {
    getAreaDetails();
  }, [siteID]);

  return (
    <div className="list-view" style={{ height: "100%" }}>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={10} xl={10}>
          <div className="mb-2">
            <Title level={3} className="mt-0">
              Area
            </Title>
            <Button
              icon={<PlusOutlined />}
              className="mb-5"
              style={{ width: "100%" }}
              onClick={() => setIsAddAreaModalOpen(true)}
            >
              New Area
            </Button>

            {loading ? (
              <Skeleton />
            ) : (
              <List
                dataSource={areaDetails}
                size="large"
                renderItem={(item) => (
                  <List.Item
                    className={
                      selectedInfoArea?.ID == item.ID
                        ? "ant-list-item list-item-selected"
                        : "ant-list-item list-item"
                    }
                    onClick={() => {
                      setSelectedInfoArea(item);
                    }}
                  >
                    <Flex
                      justify="space-between"
                      style={{
                        width: "100%",
                      }}
                    >
                      <div>{item.Name}</div>

                      <Flex gap={8}>
                        <div className="mr-2">
                          <Tooltip title="Edit">
                            <EditOutlined
                              onClick={() => {
                                setSelectedEditArea(item);
                                setIsEditAreaModalOpen(true);
                              }}
                              style={{
                                color:
                                  selectedInfoArea?.ID == item.ID
                                    ? "var(--ant-color-white)"
                                    : "var(--ant-color-primary)",
                              }}
                            />
                          </Tooltip>
                        </div>
                        <div>
                          <Tooltip title="Delete">
                            <Popconfirm
                              title="Delete Area"
                              description={"Are you sure to delete this area?"}
                              onConfirm={() => {
                                deleteArea(item.ID);
                              }}
                              okText="Yes"
                              cancelText="No"
                            >
                              <DeleteOutlined
                                style={{ color: "var(--ant-color-error)" }}
                              />
                            </Popconfirm>
                          </Tooltip>
                        </div>
                      </Flex>
                    </Flex>
                  </List.Item>
                )}
              />
            )}
          </div>
        </Col>

        <Col xs={24} sm={24} md={24} lg={10} xl={10}>
          <AreaDetails selectedArea={selectedInfoArea} />
        </Col>
      </Row>

      <Modal
        title="Add Area"
        open={isAddAreaModalOpen}
        footer={null}
        closable={false}
        destroyOnClose={true}
        maskClosable={false}
      >
        <Divider className="mb-4 mt-0"></Divider>
        <AreaForm
          mode="add"
          setIsAreaFormModalOpen={setIsAddAreaModalOpen}
          siteID={siteID}
          refreshList={getAreaDetails}
        />
      </Modal>

      <Modal
        title="Edit Area"
        open={isEditAreaModalOpen}
        footer={null}
        closable={false}
        destroyOnClose={true}
        maskClosable={false}
      >
        <Divider className="mb-4 mt-0"></Divider>
        <AreaForm
          mode="edit"
          setIsAreaFormModalOpen={setIsEditAreaModalOpen}
          siteID={siteID}
          refreshList={getAreaDetails}
          initialValues={selectedEditArea}
          setSelectedInfoArea={setSelectedInfoArea}
        />
      </Modal>
    </div>
  );
}
